import { toPng } from 'html-to-image';

/**
 * html-to-image 1.11.12+ breaks React Flow edges (xyflow#2118). We pin 1.11.11.
 * We still inline computed stroke on paths so CSS variables survive SVG serialization.
 */
function waitForNextPaint(): Promise<void> {
    return new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve());
        });
    });
}

function inlineReactFlowEdgePathsForHtmlToImage(root: HTMLElement): () => void {
    const paths = root.querySelectorAll<SVGPathElement>('.react-flow__edge-path');
    const backups = new Map<SVGPathElement, string>();

    paths.forEach((path) => {
        backups.set(path, path.style.cssText);
        const computed = getComputedStyle(path);
        path.style.stroke = computed.stroke;
        path.style.strokeWidth = computed.strokeWidth;
        path.style.fill = computed.fill;
        path.style.strokeLinecap = computed.strokeLinecap;
        path.style.strokeLinejoin = computed.strokeLinejoin;
    });

    return () => {
        backups.forEach((cssText, path) => {
            path.style.cssText = cssText;
        });
    };
}

export async function captureFamilyTreeViewportToPng(dom: HTMLElement, options?: Parameters<typeof toPng>[1]): Promise<string> {
    await waitForNextPaint();

    if (document.fonts?.ready) {
        try {
            await document.fonts.ready;
        } catch {
            // ignore — capture still proceeds
        }
    }

    const restore = inlineReactFlowEdgePathsForHtmlToImage(dom);
    try {
        return await toPng(dom, options);
    } finally {
        restore();
    }
}
